import { Component, Input } from '@angular/core';

@Component({
  selector: 'mfpc-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent {
  @Input() hint: string;

  @Input() set errors(value: string[]) {
    this.error = value ? value[0] : '';
  }

  @Input() controlName: string;

  error: string = '';
}
